import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cancelButton: {
      flexBasis: 150,
    },
    applyButton: {
      marginLeft: 18,
      height: 54,
      flexBasis: 150,
    },
    rangeField: {
      maxWidth: 'calc(100% / 2 - 10px)',
      [theme.breakpoints.up('md')]: {
        maxWidth: 170,
      },
    },
  }),
);
